import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MainPhoneState, PHONE } from '../main-phone-state';

export function getReducers(): ActionReducerMap<MainPhoneState> {
  return {
    phone: StateUtils.loaderReducer<string>(PHONE),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<MainPhoneState>> = new InjectionToken<
  ActionReducerMap<MainPhoneState>
>('MainPhoneReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
